<template>
  <div class="form-field invalid">
    <label class="form-label">
      {{ label }}

      <span class="mandatory-marker">
        *
      </span>
    </label>

    <school-search v-model="address"
                   :validate-required="true"
                   :default-to-search="true"
                   :search-type-id="searchTypeId"
                   :show-validation="showValidation"
                   :enable-manual-entry="schoolSearchEnableManualEntry"
                   :help-text="helpText"
                   :placeholder="label"
                   :allow-non-search-registration="allowNonSearchRegistration"
                   :non-search-organisation-id="nonSearchOrganisationId"
                   :non-search-label="nonSearchLabel"
                   aria-label="Search for your school by postcode"></school-search>

    <span v-if="showValidation && !isValid"
          class="validation-message">
      Required
    </span>
  </div>
</template>

<script>
import vmodelMixin from "~/mixins/vmodelMixin";
import validationMixin from "~/mixins/validationMixin";
import SchoolSearch from "#/Registration/SchoolSearch.vue";

export default {
  name: "SchoolSearchOrganisationCollectionMethod",
  components: {
    SchoolSearch
  },
  mixins: [vmodelMixin, validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    schoolSearchEnableManualEntry: {
      type: Boolean,
      default: false
    },
    searchTypeId: {
      type: Number,
      default: 1
    },
    helpText: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: "School"
    },
    allowNonSearchRegistration: {
      type: Boolean,
      default: false
    },
    nonSearchOrganisationId: {
      type: String,
      default: null
    },
    nonSearchLabel: {
      type: String,
      default: null
    }
  },
  data: () => ( {
    mutable: null,
    address: {
      orgId: "",
      name: "",
      line1: "",
      line2: "",
      line3: "",
      town: "",
      region: "",
      postcode: "",
      organisation: ""
    }
  } ),
  computed: {
    isValid () {
      let result = false;

      if ( this.mutable.orgId || ( this.address.name && this.address.postcode ) ) {
        result = true;
      }

      return result;
    }
  },
  watch: {
    address: {
      handler ( val ) {
        this.copyToMutable( val );
        this.validate();
      },
      deep: true
    },
    mutable: {
      handler ( val ) {
        this.copyFromMutable( val );
      },
      deep: true
    }
  },
  methods: {
    copyToMutable ( address ) {
      this.mutable.orgId = address.orgId;
      this.mutable.orgName = address.name || address.organisation;
      this.mutable.address1 = address.line1;
      this.mutable.address2 = address.line2;
      this.mutable.address3 = address.line3;
      this.mutable.townCity = address.town;
      this.mutable.region = address.region;
      this.mutable.postCode = address.postcode;
    },
    copyFromMutable ( mutable ) {
      this.address.orgId = mutable.orgId;
      this.address.name = mutable.orgName;
      this.address.organisation = mutable.orgName;
      this.address.line1 = mutable.address1;
      this.address.line2 = mutable.address2;
      this.address.line3 = mutable.address3;
      this.address.town = mutable.townCity;
      this.address.region = mutable.region;
      this.address.postcode = mutable.postCode;
    }
  }
};
</script>

<style lang="less" scoped>
</style>
